import { Row, Col, ButtonGroup, Dropdown, DropdownToggle, DropdownItem, DropdownMenu } from "reactstrap";
import { PriceTabButton } from "./components/PriceTabButton";
import { PriceTabToolbarProps } from "./types/PriceTabTypes";
import { useState } from "react";

export const PriceTabToolbar = ({
  selectedProductRowId,
  hasUnsavedChanges,
  hasSelectedRow,
  hasData,
  isRefreshing,
  isRefreshingPriceList,
  refreshPriceListType,
  selectedPriceListRowId,
  onNew,
  onSave,
  onCancel,
  onDelete,
  onAssignToAll,
  onRefresh,
  changedCellsCount,
  onRefreshProductPriceList,
  onRefreshPriceList,
  onRefreshAllPriceLists
}: PriceTabToolbarProps) => {

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <Row className="mb-3">
      <Col>
        <ButtonGroup className="gap-2">
          <PriceTabButton onClick={onNew} icon="ri-add-line" variant="primary" disabled={!selectedProductRowId}>
            New
          </PriceTabButton>
          <PriceTabButton onClick={onSave} icon="ri-save-line" variant="success" disabled={!hasUnsavedChanges}>
            Save
          </PriceTabButton>
          <PriceTabButton onClick={onCancel} icon="ri-close-line" variant="warning" disabled={!hasUnsavedChanges}>
            Cancel
          </PriceTabButton>
          <PriceTabButton onClick={onDelete} icon="ri-delete-bin-line" variant="danger" disabled={!hasSelectedRow}>
            Delete
          </PriceTabButton>
          <PriceTabButton onClick={onAssignToAll} icon="ri-share-line" variant="info" disabled={!hasData}>
            Assign to All
          </PriceTabButton>
          {/* <PriceTabButton 
            onClick={onRefresh} 
            icon={isRefreshing ? "" : "ri-refresh-line"} 
            variant="primary" 
            disabled={isRefreshing}
          >
            {isRefreshing ? (
              <>
                <span 
                  className="spinner-border spinner-border-sm me-1" 
                  role="status"
                  aria-hidden="true"
                />
                Refreshing...
              </>
            ) : (
              "Refresh"
            )}
          </PriceTabButton> */}
          {/* <PriceTabButton
            onClick={onRefreshPriceList}
            icon={isRefreshingPriceList ? "" : "ri-refresh-line"}
            variant="info"
            disabled={!hasSelectedRow || isRefreshingPriceList}
          >
            {isRefreshingPriceList ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                />
                Refreshing...
              </>
            ) : (
              "Refresh Price List"
            )}
          </PriceTabButton> */}
          <Dropdown
            isOpen={isOpen}
            toggle={() => {}}
            disabled={!hasSelectedRow || isRefreshingPriceList}
          >
            <DropdownToggle
              tag="button"
              className="btn btn-soft btn-info btn-sm"
              disabled={!hasSelectedRow || isRefreshingPriceList}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onRefreshPriceList(); // Send refresh request
              }}
            >
              Refresh Price List
              <i
                className="ri-arrow-down-s-line ps-3"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toggle(); // Open dropdown
                }}
              ></i>
            </DropdownToggle>
            <DropdownMenu>
              {refreshPriceListType.map((item) => (
                <DropdownItem
                  key={item.value}
                  className="btn-sm py-1 px-3"
                  onClick={() => {
                    // Handle dropdown item selection
                    onRefreshAllPriceLists(item.type);
                    toggle();
                  }}
                >
                  {item.label}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        </ButtonGroup>
        {hasUnsavedChanges && (
          <div className="text-muted small ms-3 d-flex align-items-center">
            <i className="ri-edit-line me-1"></i>
            {changedCellsCount} change(s) pending
          </div>
        )}
      </Col>
    </Row>
  );
};